import * as yup from 'yup';
export type ShipDateModel = {
    shipDate?: any
}

export const ShipDateInitialState: ShipDateModel = {
    shipDate: ''
}

export const ShipDateSchema = yup.object().shape({
    shipDate: yup.string().required('Ship Date is required'),
})